import { useEffect } from 'react';

declare global {
    interface Window {
        metabaseConfig?: {
            theme: { preset: string };
            isGuest: boolean;
            instanceUrl: string;
        };
    }

    namespace JSX {
        interface IntrinsicElements {
            'metabase-dashboard': React.DetailedHTMLProps<
                React.HTMLAttributes<HTMLElement> & {
                    token?: string;
                    'with-title'?: string;
                    'with-downloads'?: string;
                    'initial-parameters'?: string;
                },
                HTMLElement
            >;
        }
    }
}

const EMBED_SCRIPT_ID = 'metabase-embed-script';

interface MetabaseDashboardProps {
    token: string;
    instanceUrl: string;
    withTitle?: boolean;
    withDownloads?: boolean;
    initialParameters?: string;
    height?: string;
}

const MetabaseDashboard = ({
    token,
    instanceUrl,
    withTitle = false,
    withDownloads = true,
    initialParameters,
    height = '4000px',
}: MetabaseDashboardProps) => {
    useEffect(() => {
        window.metabaseConfig = {
            theme: { preset: 'light' },
            isGuest: true,
            instanceUrl,
        };

        if (document.getElementById(EMBED_SCRIPT_ID)) return;

        const script = document.createElement('script');
        script.id = EMBED_SCRIPT_ID;
        script.src = `${instanceUrl}/app/embed.js`;
        script.defer = true;
        document.head.appendChild(script);
    }, [instanceUrl]);

    return (
        <div className="w-full" style={{ height }}>
            <metabase-dashboard
                token={token}
                with-title={String(withTitle)}
                with-downloads={String(withDownloads)}
                initial-parameters={initialParameters}
                style={{ display: 'block', width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default MetabaseDashboard;
